import { ref } from 'vue';
import { segmentsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';
import type { ClientContext } from '~/services/contextClient';

export const useSegmentsContactsCount = createGlobalState(() => {
    // [segmentId]: contactsCount
    // undefined = loading
    // null = not found
    const contactsCount = ref<Record<number, number>>({});

    const fetching = ref(false);

    const fetchSegmentsContactsCount = async (
        context: ClientContext,
        segmentIds: number[],
        params?: {
            group_ids?: string[];
        }
    ) => {
        // remove existing ids to avoid computing them again
        segmentIds = segmentIds.filter((segmentId) => !(segmentId in contactsCount.value));

        if (!segmentIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchSegmentsContactsCount(context, segmentIds, params);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            const response = await segmentsClient.getSegmentsContactsCount(context, {
                segment_ids: segmentIds,
                ...params,
            });

            segmentIds.forEach((segmentId) => {
                contactsCount.value[segmentId] = response.data.counts[segmentId] ?? 0;
            });
        } finally {
            fetching.value = false;
        }
    };

    const resetContactsCount = () => {
        contactsCount.value = {};
        fetching.value = false;
    };

    return {
        fetchSegmentsContactsCount,
        contactsCount,
        resetContactsCount,
    };
});
